import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
        setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('auth');
  };

  const isAuthenticated = () => {
    if (!user) return false;

    // Check if token exists
    const token = user.accessToken || user.token;
    if (!token) return false;

    // Basic token expiration check (if token contains exp field)
    try {
      if (user.expiresAt && Date.now() > user.expiresAt) {
        logout(); // Auto logout if expired
        return false;
      }
    } catch (error) {
      console.error('Token validation error:', error);
    }

    return true;
  };

  const updateUserBalance = (newBalance) => {
    if (user) {
      const updatedUser = {
        ...user,
        coinBalance: newBalance
      };
      setUser(updatedUser);
      localStorage.setItem('user', JSON.stringify(updatedUser));
    }
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated,
    updateUserBalance,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};